import ParameterFieldBase from '../../../../_common/platform/ts/ParameterFieldBase';
import EditComponent, {IChartAxisFieldOptions_inThemes} from './ChartAxisField_inThemes';

export class ChartAxisField_inThemes extends ParameterFieldBase<IChartAxisFieldOptions_inThemes> {
    public static EditComponent = EditComponent;
    public static getDefaultValue() {
        return {};
    }

    constructor(glob, title: string, validators?: any, defaultVal?: any, options?: IChartAxisFieldOptions_inThemes) {
        if (defaultVal == null) {
            defaultVal = ChartAxisField_inThemes.getDefaultValue();
        }

        super(glob, title, [], validators, defaultVal, options);
    }
}
